import { Injectable } from '@angular/core';
import {environment} from '../../../environments/environment';
import {HttpClient} from '@angular/common/http';
import {Equipement} from '../models/equipement.model';

@Injectable({
  providedIn: 'root'
})
export class EquipementService {

  api:string = environment.api+'/equipments';
  constructor(private http: HttpClient) { }

  getEquipements(page:number,size:number){
    return this.http.get(this.api+'/getAll?pageNo='+page+'&pageSize='+size);
  }

  findAllEquipements(){
    return this.http.get(this.api+'/findAll');
  }

  updateEquipement(equipement:Equipement){
    return this.http.put(this.api,equipement);
  }

  createEquipement(equipement:Equipement){
    return this.http.post(this.api,equipement);
  }

  deleteEquipement(equipement:Equipement){
    return this.http.delete(this.api+'/'+equipement.equipmentId);
  }

  getEquipementsByFloorAndRoomName(floorId:number,roomName:string){
    return this.http.get(this.api+'/'+floorId+'/'+roomName)
  }
  
}
